/**
 * @generated SignedSource<<3aecfbc4d8c843a04505417c000dc5f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Locale = "EN" | "LT";
export type TranslatableTextFieldTranslateButtonRefetchQuery$variables = {
  id: string;
  to: Locale;
  translate?: boolean | null;
};
export type TranslatableTextFieldTranslateButtonRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_data">;
};
export type TranslatableTextFieldTranslateButtonRefetchQuery = {
  response: TranslatableTextFieldTranslateButtonRefetchQuery$data;
  variables: TranslatableTextFieldTranslateButtonRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "translate"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranslatableTextFieldTranslateButtonRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "translate",
            "variableName": "translate"
          }
        ],
        "kind": "FragmentSpread",
        "name": "TranslatableTextFieldTranslateButton_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranslatableTextFieldTranslateButtonRefetchQuery",
    "selections": [
      {
        "condition": "translate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "to",
                "variableName": "to"
              }
            ],
            "kind": "ScalarField",
            "name": "translateTextTranslation",
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4e36c461792b8e233feca3f3e4b9d4a3",
    "id": null,
    "metadata": {},
    "name": "TranslatableTextFieldTranslateButtonRefetchQuery",
    "operationKind": "query",
    "text": "query TranslatableTextFieldTranslateButtonRefetchQuery(\n  $id: ID!\n  $to: Locale!\n  $translate: Boolean = false\n) {\n  ...TranslatableTextFieldTranslateButton_data_4krjNH\n}\n\nfragment TranslatableTextFieldTranslateButton_data_4krjNH on Query {\n  translateTextTranslation(id: $id, to: $to) @include(if: $translate)\n}\n"
  }
};
})();

(node as any).hash = "b941093e2a770d34300694c407fd9fec";

export default node;
